import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  createS3EventAsync,
  selectActionLoading,
  selectLoading,
  selectSelectedS3Event,
} from "../../../../store/s3/eventsSlice";
import { S3MqttEventSchema } from "../../../../utils/validations";
import { useEffect } from "react";
import { S3EventsUrl } from "../../../../utils/urls";
import { useNavigate } from "react-router-dom";
import useGetS3Events from "../../../../hooks/useGetS3Events";
import { Button, Input, Textarea } from "djuno-design";

const MqttForm = () => {
  const event = useAppSelector(selectSelectedS3Event);
  const loading = useAppSelector(selectActionLoading);
  const eventsLoading = useAppSelector(selectLoading);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const getS3Events = useGetS3Events();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(S3MqttEventSchema),
  });

  useEffect(() => {
    if (event) {
    } else {
    }
  }, [event, setValue]);

  const onSubmit = (data: any) => {
    let keyValues = [
      {
        key: "broker",
        value: data.broker,
      },
      {
        key: "topic",
        value: data.topic,
      },
      {
        key: "username",
        value: data.username,
      },
      {
        key: "password",
        value: data.password,
      },
      {
        key: "qos",
        value: data.qos,
      },
      {
        key: "keep_alive_interval",
        value: data.keep_alive_interval,
      },
      {
        key: "reconnect_interval",
        value: data.reconnect_interval,
      },
      {
        key: "queue_dir",
        value: data.queue_dir,
      },
      {
        key: "comment",
        value: data.comment,
      },
    ];
    if (data.queue_limit !== null) {
      keyValues = [
        ...keyValues,
        {
          key: "queue_limit",
          value: data.queue_limit.toString(),
        },
      ];
    }
    const formData = {
      key_values: keyValues,
    };
    // if (event) {
    // dispatch(
    //   updateS3EventAsync({
    //     id: event.Id,
    //     data: {
    //       label: data.label,
    //     },
    //   })
    // ).then((action) => {
    //   if (action.type === "s3-events/update/fulfilled") {
    //     // handleClearComponent();
    //     dispatch(handleHideEditor());
    //     dispatch(getS3EventsAsync());
    //     reset();
    //   }
    // });
    // } else {
    dispatch(
      createS3EventAsync({
        event: "mqtt",
        identifier: data.identifier,
        data: formData,
      })
    ).then((action) => {
      if (action.type === "s3-events/create/fulfilled") {
        getS3Events(() => {
          reset();
          navigate(S3EventsUrl);
        });
      }
    });
    // }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col w-full gap-5">
        <Input
          label="Identifier"
          tooltip={{
            className: "!text-xs",
            content: "Unique descriptive string for this destination",
          }}
          placeholder="Enter Destination Identifier"
          {...register("identifier")}
          error={errors.identifier?.message}
          required
        />

        <Input
          label="Broker"
          tooltip={{
            className: "!text-xs",
            content: "MQTT server endpoint e.g. `tcp://localhost:1883`",
          }}
          placeholder="Enter Broker"
          {...register("broker")}
          error={errors.broker?.message}
        />

        <Input
          label="Topic"
          tooltip={{
            className: "!text-xs",
            content: "Name of the MQTT topic to publish",
          }}
          placeholder="Enter Topic"
          {...register("topic")}
          error={errors.topic?.message}
        />

        <Input
          label="Username"
          tooltip={{ className: "!text-xs", content: "MQTT Username" }}
          placeholder="Enter Username"
          {...register("username")}
          error={errors.username?.message}
        />

        <Input
          label="Password"
          tooltip={{ className: "!text-xs", content: "MQTT Password" }}
          placeholder="Enter Password"
          {...register("password")}
          error={errors.password?.message}
        />

        <Input
          label="QOS"
          tooltip={{
            className: "!text-xs",
            content: "Set the quality of service priority, defaults to '0'",
          }}
          placeholder="Enter QOS"
          {...register("qos")}
          error={errors.qos?.message}
        />

        <Input
          label="Keep Alive Interval"
          tooltip={{
            className: "!text-xs",
            content: "Keep-alive interval for MQTT connections in s,m,h,d",
          }}
          placeholder="Enter Keep Alive Interval"
          {...register("keep_alive_interval")}
          error={errors.keep_alive_interval?.message}
        />

        <Input
          label="Reconnect Interval"
          tooltip={{
            className: "!text-xs",
            content: "Reconnect interval for MQTT connections in s,m,h,d",
          }}
          placeholder="ِEnter Reconnect Interval"
          {...register("reconnect_interval")}
          error={errors.reconnect_interval?.message}
        />

        <Input
          label="Queue Directory"
          tooltip={{
            className: "!text-xs",
            content:
              "Staging directory for undelivered messages e.g. '/home/events'",
          }}
          placeholder="ِEnter Queue Directory"
          {...register("queue_dir")}
          error={errors.queue_dir?.message}
        />

        <Input
          label="Queue Limit"
          tooltip={{
            className: "!text-xs",
            content:
              "Maximum limit for undelivered messages, defaults to '10000'",
          }}
          placeholder="ِEnter Queue Limit"
          {...register("queue_limit")}
          type="number"
          error={errors.queue_limit?.message}
        />

        <Textarea
          label="Comment"
          placeholder="Enter custom notes if any"
          {...register("comment")}
          error={errors.comment?.message}
        />
      </div>
      <div className="mt-4 flex justify-end">
        <Button
          loading={loading || eventsLoading}
          uiType="primary"
          disabled={loading || eventsLoading}
          type="submit"
        >
          {event ? "Update Evet Target" : "Save Evet Target"}
        </Button>
      </div>
    </form>
  );
};
export default MqttForm;
